import React from 'react';
import * as style from '../../styles/loading.module.scss';
import { SquareSpinner } from '../spinners/SquareSpinner';

export const Loading = () => (
  <div className={style.waiting}>
    <SquareSpinner />
  </div>
);
